"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconSizePropTypes = exports.IconSizes = void 0;
// This file still exports PropTypes to support existing .js files.
// Once all files are TS, the `IconSizePropTypes` should be removed and this file
// renamed to "../types.ts" instead.
const prop_types_1 = __importDefault(require("prop-types"));
var IconSizes;
(function (IconSizes) {
    IconSizes["Xsmall"] = "xsmall";
    IconSizes["Small"] = "small";
    IconSizes["Medium"] = "medium";
    IconSizes["Default"] = "default";
    IconSizes["Large"] = "large";
    /* eslint-disable @typescript-eslint/naming-convention */
    /** @deprecated Use IconSizes.Xsmall instead */
    IconSizes["xsmall"] = "xsmall";
    /** @deprecated Use IconSizes.Small instead */
    IconSizes["small"] = "small";
    /** @deprecated Use IconSizes.Medium instead */
    IconSizes["medium"] = "medium";
    /** @deprecated Use IconSizes.Default instead */
    IconSizes["default"] = "default";
    /** @deprecated Use IconSizes.Large instead */
    IconSizes["large"] = "large";
    /* eslint-enable @typescript-eslint/naming-convention */
})(IconSizes = exports.IconSizes || (exports.IconSizes = {}));
exports.IconSizePropTypes = prop_types_1.default.oneOf(Object.values(IconSizes));
//# sourceMappingURL=IconSizes.js.map